module.exports = __webpack_public_path__ + "static/media/400069_02.60630263.png";